import { observable, runInAction } from "mobx";
import { api, apiOperacao } from "../../api";
import { IEmpresa, IImportInfo, newEmpresa, newIImportInfo } from "../../model";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _ImportStore {
  obs = observable({
    descricao_import: "" as string,
    selectedEmpresaImport: newEmpresa() as IEmpresa,
    importarXmls: false as boolean,
    tarefas: [] as any[],
    erros_import: [] as any[],
    avisos_import: [] as any[],
    import_summary: newIImportInfo() as IImportInfo,
    isValida: false as boolean,
    loadingImport: false as boolean,
    loadingDownloadXml: false as boolean,
    rewritexml: "1" as string,
  })

  constructor() {
  }

  async handldeCreateTaskImport(data) {
    this.obs.loadingImport = true

    try {
      let resp = await apiOperacao("importacao").post("/importacao/create-task", data);

      if (resp.data.ok == false) {
        toast.warning(resp.data.erro, {});
      } else {
        toast.success('Importado com sucesso!', {});
      }

    } catch (ex) {
      if (ex.response.status == 413) {
        toast.warning('Tamanho de arquivo máximo aceitável 300 MB.', {});
      } else {
        toast_error(ex, `Erro ao realizar importação, tente novamente mais tarde.`);
      }
    }

    this.obs.loadingImport = false
    this.obs.selectedEmpresaImport = newEmpresa()
    this.obs.descricao_import = ""
    this.handleConsulta()
  }

  async handleConsultaTodas(page: number, cnpj: string, status: number, data1: string, data2: string) {
    try {
      let data = {
        paged: page,
        limit: 15,
        cnpj: cnpj == "" ? null : cnpj,
        date1: data1 == "" ? null : data1,
        date2: data2 == "" ? null : data2,
        status: status == 5 ? null : status
      };

      let tarefa = await apiOperacao("importacao").post("/importacao/index-task", data);

      this.obs.tarefas = [];
      this.obs.tarefas = tarefa.data.tasks;

    } catch (ex) {
      toast_error(ex, `Erro ao consultar importação tasks, tente novamente mais tarde.`);
    }
  }

  async summary_import(importacao_id: string, tipo: string, modelo: string) {
    try {
      this.obs.isValida = false;
      this.obs.import_summary = newIImportInfo();

      let data = {
        importacao_id: importacao_id,
        tipo: tipo,
        modelo: modelo
      }

      let resp = await apiOperacao("importacao").post(`/importacao/summary`, data);

      runInAction(() => {
        if (Array.isArray(resp.data)) {
          this.obs.isValida = true
        } else {
          this.obs.isValida = false;
          this.obs.import_summary = resp.data
        }
      });
    } catch (ex) {
      toast_error(ex, `Erro ao carregar importação summary, tente novamente mais tarde.`);
    }

  }

  async busca_erros(page, limit, importId) {
    try {
      let data = { page: page, limit: limit, importacao_id: importId }

      let resp = await apiOperacao("importacao").post(`/importacao/erros`, data);

      runInAction(() => {
        if (resp.data.length > 0) {
          resp.data?.map(values => {
            values.itens?.map(erros => {
              this.obs.erros_import.push(erros);
            })
          })
        }
      });
    } catch (ex) {
      toast_error(ex, `Erro ao carregar importação erros, tente novamente mais tarde.`);
    }
  }

  async busca_avisos(page, limit, importId) {

    try {
      let data = { page: page, limit: limit, importacao_id: importId }

      let resp = await apiOperacao("importacao").post(`/importacao/avisos`, data);

      runInAction(() => {
        if (resp.data.length > 0) {
          resp.data?.map(values => {
            values.itens?.map(avisos => {
              this.obs.avisos_import.push(avisos);
            })
          })
        }
      });
    } catch (ex) {
      toast_error(ex, `Erro ao carregar importação avisos, tente novamente mais tarde.`);
    }
  }

  async handleConsulta() {
    this.obs.descricao_import = ""
    await this.handleConsultaTodas(1, "", 5, "", "");
    this.obs.importarXmls = false
  }

  async handleDownloadXml(chave: string) {
    try {
      this.obs.loadingDownloadXml = true

      let params = {
        chave: chave
      }

      let resp = await apiOperacao("importacao").post(`/importacao/download`, params);

      if (resp.data.ok) {
        const linkSource = `data:application/xml;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = chave + ".xml";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.error('XML expirado, poís passou dos 7 (sete) dias da Importação.', {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao realizar download xmls importação, tente novamente mais tarde.`);
    }

    this.obs.loadingDownloadXml = false

  }

}

export const ImportStore = new _ImportStore();
